export class PanelItems {
    public Id: number;
    public PanelId: number;
    public ConfigurationId: number;
    public PanelItemName: string;
    public PanelItemIcon: string;
    public PanelItemTskDesc: string;
}
